import {
  JSONEditor as LibJSONEditor,
  JSONEditorProps as LibJSONEditorProps,
} from "@flaminem/ui-components";
import { FC } from "react";

export type JSONEditorProps = LibJSONEditorProps;

export const JSONEditor: FC<JSONEditorProps> = (props) => <LibJSONEditor {...props} />;
